// Enterprise cost tab — one org's OpenAI spend, scoped to its members. Reuses
// the global Cost dashboard's spend view via CostSpendTab(corporateId).

import React, { useState } from "react";
import { useCorporate } from "../CorporateContext";
import { WindowToggle } from "../../../../Components/admin/reporting/primitives";
import {
  CustomRangePopover,
  DashboardSurface,
  Toolbar,
} from "../../../../Components/admin/reporting/controls";
import CostSpendTab from "../../Cost/CostSpendTab";

const Cost = () => {
  const { corporate } = useCorporate();
  const corporateId = corporate?.id || corporate?._id;
  const [windowDays, setWindowDays] = useState(30);
  const [range, setRange] = useState(null);

  return (
    <DashboardSurface fillViewport={false}>
      <div className="space-y-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold tracking-tight">LLM cost</h2>
            <p className="text-sm text-muted-foreground">
              OpenAI spend across this enterprise's members — voice &amp; chat.
            </p>
          </div>
          <WindowToggle
            value={range ? null : windowDays}
            onChange={(d) => {
              setRange(null);
              setWindowDays(d);
            }}
          />
        </div>

        <Toolbar>
          <div className="flex items-center gap-1.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              Range
            </span>
            <CustomRangePopover
              active={range}
              onApply={(r) => setRange(r)}
              onClear={() => setRange(null)}
            />
          </div>
        </Toolbar>

        {corporateId ? (
          <CostSpendTab
            windowDays={windowDays}
            range={range}
            corporateId={corporateId}
          />
        ) : null}
      </div>
    </DashboardSurface>
  );
};

export default Cost;
